import AuthorizeForm, { AuthorizeFormProps } from './AuthorizeForm';

export type { AuthorizeFormProps };
export default AuthorizeForm;
